module.exports = __webpack_public_path__ + "static/img/iaor_logo.719cfac.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iaor_logo.gif
// module id = H7nD
// module chunks = 3